export default {
  // Feed Report Widget Data
  feedReportData: null,
  
  // Loading states
  loadingFeedData: false,
  
  // Error states
  feedDataError: null,
  
  // Queues data (for dialog selection)
  availableQueues: [],
  loadingQueues: false,
  
  // Users data (for dialog selection)
  availableUsers: [],
  loadingUsers: false,
  
  // Raw group users data for debugging
  groupUsers: [],
  
  // Current selections
  selectedQueues: [],
  selectedUsers: [],
  selectedDateRange: [],
  
  // Date type selection (system date or feed date)
  dateType: 'system' // 'system' or 'feed'
}